import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { PreviewModal } from 'hlj-components'
import mainStore from '@components/Main/store'

@observer
export default class extends Component {
  render() {
    const {
      popupVisible,
      popupPoster: { image_path },
      closePopup,
      gotoPopup
    } = mainStore.posterStore

    return popupVisible ? (
      <PreviewModal visible={popupVisible} onCancel={closePopup}>
        <img onClick={gotoPopup} src={image_path} />
      </PreviewModal>
    ) : null
  }
}
